import { defineMessages, IntlShape } from "react-intl";

import BoundaryLegendAggregationType from "@mapmycustomers/shared/enum/boundaryLegends/BoundaryLegendAggregationType";

import { getDisplayName } from "./getDisplayName";

export const messages = defineMessages<BoundaryLegendAggregationType>({
  [BoundaryLegendAggregationType.AVG]: {
    id: "boundaryLegendAggregationType.avg",
    defaultMessage: "Mean",
    description: "Title of the Avg aggregation option",
  },
  [BoundaryLegendAggregationType.MAX]: {
    id: "boundaryLegendAggregationType.max",
    defaultMessage: "Max",
    description: "Title of the Max aggregation option",
  },
  [BoundaryLegendAggregationType.MEDIAN]: {
    id: "boundaryLegendAggregationType.median",
    defaultMessage: "Median",
    description: "Title of the Median aggregation option",
  },
  [BoundaryLegendAggregationType.MIN]: {
    id: "boundaryLegendAggregationType.min",
    defaultMessage: "Min",
    description: "Title of the Min aggregation option",
  },
  [BoundaryLegendAggregationType.SUM]: {
    id: "boundaryLegendAggregationType.sum",
    defaultMessage: "Sum",
    description: "Title of the Sum aggregation option",
  },
  [BoundaryLegendAggregationType.VALUE_COUNT]: {
    id: "boundaryLegendAggregationType.count",
    defaultMessage: "Count",
    description: "Title of the Count aggregation option",
  },
});

const getBoundaryAggregationDisplayName = (
  intl: IntlShape,
  aggregation: BoundaryLegendAggregationType
) => getDisplayName(intl, messages, aggregation, "BoundaryLegendAggregationType");

export default getBoundaryAggregationDisplayName;
